import React from 'react';

import { OrganizationRating } from '@sravni/react-ugc/lib/OrganizationRating';
import { PAGE_TYPE } from '@sravni/ugc/lib/organizations/constants';

import { ORGANIZATION_LIST, ORGANIZATION_LIST_MFO } from '../../constants/routes';
import { ratingsListUrl } from '../../helpers/ratings';
import { checkIfMfo, ReviewType } from '../../helpers/reviews';
import { useRatingSravni } from '../../store/hooks/ratings';
import { createLinkProps } from '../../utils/routing';

interface IProps {
  type: PAGE_TYPE;
  reviewTypes: ReviewType;
}

export const RatingSravni: React.FC<IProps> = ({ type, reviewTypes }) => {
  const ratingSravni = useRatingSravni();
  const { namesType } = reviewTypes;

  if (!ratingSravni?.length) return null;

  const isMfo = checkIfMfo(type);
  const listRoute = isMfo ? ORGANIZATION_LIST_MFO : ORGANIZATION_LIST;

  const ratings = ratingSravni.map((item) => {
    const { as } = createLinkProps('/list', listRoute, {
      type: reviewTypes.itemTypeUrl,
      organization: item.organizationAlias,
    });

    return {
      link: as,
      name: item.organizationName,
      rating: item.complexCalculatedRatingValue,
      total: item.participantsCount,
      logo: item.logo,
    };
  });

  if (!ratings?.length) return null;

  return (
    <OrganizationRating
      genitive={namesType.mode9}
      list={ratings}
      listUrl={ratingsListUrl(type, reviewTypes)}
      className="h-mb-24"
    />
  );
};
